import parsePhoneNumberFromString from "libphonenumber-js";

export function createPhoneLink(phoneNumber: string, className?: string): string {
    const parsedNumber = parsePhoneNumberFromString(phoneNumber);
    if (parsedNumber?.isValid()) {
        const classAttr = className ? ` class="${className}"` : "";
        return `<a href="${parsedNumber?.getURI()}"${classAttr}>${parsedNumber?.formatInternational()}</a>`;
    }
    return phoneNumber;
}
